import React from 'react';

import {TButtonProps} from '@edna/components';

import * as S from './style';

type TProps = {
  className?: string;
  children?: React.ReactNode;
};

const ToggleButtons = React.memo<TProps>(({children, className}) => (
  <S.ToggleButtons className={className}>{children}</S.ToggleButtons>
));

export default ToggleButtons;

type TTabProps = TButtonProps & {
  className?: string;
  active?: boolean;
  onClick?: TEmptyFunction;
  children: React.ReactNode;
  isTertiary?: boolean;
};

export const ToggleButton = React.memo<TTabProps>(
  ({className, active = false, onClick, children, isTertiary, ...props}) => {
    const secondaryStyle = active ? 'primary' : 'secondary';
    const ButtonComponent = isTertiary ? S.TertiaryToggleButton : S.ToggleButton;

    return (
      <ButtonComponent
        className={className}
        role="tab"
        active={active}
        onClick={onClick}
        appearance={isTertiary ? 'tertiary' : secondaryStyle}
        {...props}
      >
        {children}
      </ButtonComponent>
    );
  },
);
